export default function (context: any): void {
  const { store } = context;
  store.dispatch("preset/updateCurrentGenre", "default");
}
